import { defineMessages } from 'react-intl-next';

export default defineMessages({
	highlightActionsPlaceholderPrompt: {
		id: 'highlight-actions.rovo-chat.placeholder-prompt',
		defaultMessage: 'Ask a question about this.',
		description: 'Placeholder prompt for highlight actions when Chat button is clicked',
	},
});
